<script>
import { Doughnut, mixins } from 'vue-chartjs'
import ChartDataLabels from 'chartjs-plugin-datalabels'

export default {
  extends: Doughnut,
  name: 'PieChart',
  mixins: [mixins.reactiveProp],
  data() {
    return {
      isLoaded: false,
      chartOptions: {
        animation: {
          duration: 500,
          easing: 'easeInOutSine'
        },
        maintainAspectRatio: false,
        legend: {
          display: false,
          position: 'bottom',
          fullWidth: true,
          labels: {
            boxWidth: 15
          }
        },
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
          }
        },
        plugins: {
          datalabels: {
            formatter: (value, ctx) => {
              let sum = 0
              let dataArr = ctx.chart.data.datasets[0].data
              dataArr.map(data => {
                sum += data
              })
              let percentage = ((value * 100) / sum).toFixed(0) + '%'
              return percentage
            },
            color: '#fff',
            font: {
              size: 12
            }
          }
        }
      }
    }
  },
  watch: {
    chartData() {
      this.$data._chart.update()
    }
  },
  computed: {},
  mounted() {
    this.addPlugin(ChartDataLabels)
    this.renderChart(this.chartData, this.chartOptions)
  },
  methods: {
    refresh() {
      this.renderChart(this.chartData, this.chartOptions)
    }
  }
}
</script>

<style lang="scss" scoped></style>
